// Moeda única do Kanban — espelho de `Deal::CURRENCY`. Não há seletor: toda
// conta atendida é brasileira; o dia em que houver outra moeda, ela entra
// aqui e no model, e o Analytics passa a somar por moeda.
export const DEAL_CURRENCY = 'BRL';

/**
 * Valor do negócio em centavos, ou `null` quando NÃO HÁ valor.
 *
 * A distinção importa e já foi bug: o model deriva `value = value_cents / 100`,
 * então negócio sem valor chega ao frontend como `value: 0.0` e o card exibia
 * "R$ 0,00" pra todo mundo — número inventado com cara de dado. A presença tem
 * que sair de `value_cents`, que é a coluna real e é nullable.
 *
 * Zero EXPLÍCITO (`value_cents: 0`) continua sendo valor: "este negócio vale
 * R$ 0,00" é uma afirmação diferente de "ninguém preencheu".
 */
export const dealValueCents = deal => {
  const cents = deal?.value_cents;
  if (cents === null || cents === undefined || cents === '') return null;
  const numeric = Number(cents);
  return Number.isNaN(numeric) ? null : numeric;
};
